import { render, staticRenderFns } from "./SuppliersListing.vue?vue&type=template&id=5b99a180&scoped=true&"
import script from "./SuppliersListing.vue?vue&type=script&lang=js&"
export * from "./SuppliersListing.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersListing.vue?vue&type=style&index=0&id=5b99a180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b99a180",
  null
  
)

export default component.exports